import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'

export class DriverHaltsFilterEntity {
  driver?: DriverEntity
  isActive?: boolean
  startDate?: string
  endDate?: string
  region?: RegionMiniEntity
  page?: number
  limit?: number
}
